export {};
//# sourceMappingURL=ISenderPostManager.js.map